export default {
  highcharts: {
    decimalPoint: ',',
    downloadJPEG: 'Pobierz obraz JPEG',
    downloadPDF: 'Pobierz dokument PDF',
    downloadPNG: 'Pobierz obraz PNG',
    downloadSVG: 'Pobierz obraz SVG',
    exportButtonTitle: 'Eksport',
    forexRate: 'Kurs średni FOREX',
    loading: 'Ładowanie...',
    months: [
      'Styczeń',
      'Luty',
      'Marzec',
      'Kwiecień',
      'Maj',
      'Czerwiec',
      'Lipiec',
      'Sierpień',
      'Wrzesień',
      'Październik',
      'Listopad',
      'Grudzień',
    ],
    printButtonTitle: 'Drukowanie',
    rangeSelectorFrom: 'Od',
    rangeSelectorTo: 'Do',
    rangeSelectorZoom: 'Przybliżenie',
    rateTypes: {
      ask: 'Najlepsza oferta sprzedaży',
      bid: 'Najlepsza oferta kupna',
      forex: 'Średni kurs na świecie',
    },
    resetZoom: 'Reset',
    resetZoomTitle: 'Reset',
    shortMonths: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    thousandsSep: ' ',
    weekdays: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    wtBestAsk: 'Najlepsza oferta sprzedaży',
    wtBestBid: 'Najlepsza oferta kupna',
  },
  calculator: {
    title: 'Calculați economiile în Walutomat',
    rangeFrom: 'Vreau să',
    forBuy: 'pentru',
    forSell: 'pentru',
    directionBuy: 'Să cumpăr',
    directionSell: 'Vânzare',
    payText: 'veți plăti',
    sellText: 'veți primi',
    buySelect: 'cumpărați',
    sellSelect: 'vinde',
    rateText: 'Rata de schimb',
    amountText: 'Suma',
    includes: 'Include',
    commission: '{{commission}}% comision',
    howItWorks: '',
    banksComapreOpen: 'Comparați cu alții',
    banksComapreClose: 'Închideți lista',
    savingsMonthly: 'Economisiți chiar și o singură dată cu Walutomat',
    savingsYearly: 'înlocuind pe tot parcursul anului, în fiecare lună.',
    conjunction: 'și',
    serverError: 'Eroare de comunicare cu serverul',
    unsupportedPair: 'În prezent nu oferim rate pentru perechea valutară selectată.',
    infoError: {
      exchange: 'La Walutomat.pl puteți schimba direct',
      transactionFee:
        'și înapoi. O astfel de tranzacție la bancă este asociată cu un comision ridicat, ajungând de obicei chiar și la 5-10% din suma de schimb.',
    },
    spinnerError: 'A existat o problemă cu descărcarea datelor',
  },
  dashboard: {
    canEditPost: 'Możesz edytować wpis',
    postExists: 'Wpis o takim tytule już istnieje',
    postNotExists: 'Wpis o takim tytule nie istnieje',
    emptyPostTitle: 'Dodaj tytuł wpisu',
    error: 'Coś poszło nie tak :(',
  },
  widgetCalculator: {
    title: 'Verificați cursurile și{{nbsp}}schimbați moneda în{{nbsp}}Walutomat – rapid și{{nbsp}}avantajos.',
    actualRate: 'Curs actual',
    exchangeAmount: 'Valoarea schimbului',
    buySelect: 'Cumpăr',
    sellSelect: 'Vând',
    buttonText: 'Schimb',
  },
  formValidation: {
    emptyField: 'Câmpul nu poate fi gol',
    requiredField: 'Câmpul este obligatoriu',
    passwordToShort: 'Parola trebuie să aibă 8 caractere',
    emailNotValid: 'Câmpul trebuie să conțină o adresă de e-mail validă',
    emailReserved: 'Adresa de e-mail este deja ocupată',
    rateEmpty: 'Toate câmpurile trebuie completate',
    serverUnknownError: 'Eroare de comunicare cu serverul',
    invalidCharacters: 'Câmpul conține caractere invalide',
    phoneNotValid: 'Numărul de telefon este incorect',
    checkBoxBelow: 'Please tick the box below to send a message',
  },
  password: {
    show: 'arată',
    hide: 'ascunde',
  },
  howItWorks: {
    showButton: 'Arată mai mult',
    hideButton: 'Arată mai puțin',
  },
}
